import Header from "./Header";
import OrderSummary from "./OrderSummary";
import AvatarUpload from "../../../../common/AvatarUpload";
import { initialsValue } from "../../../../../helpers";
import InfoCard from "../../../../common/InfoCard";
import { useSelector } from "react-redux";

export default function TicketDetails({ details }) {
  const { session } = useSelector((state) => state?.authProvider);

  return (
    <div className="bg-white p-6 max-w-7xl mx-auto">
      <div className="col-span-12 px-6 flex items-center relative">
        <AvatarUpload
          src={details?.image instanceof File ? URL.createObjectURL(details?.image) : details?.image?.url}
          alt="profile"
          initial={initialsValue(details?.name)}
        />
      </div>
      <Header data={details} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
        <div className="lg:col-span-12 space-y-6">
          <OrderSummary data={details} />
        </div>
      </div>
      {session?.user?.role === "admin" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          <InfoCard heading="Event" title={details?.eventData?.title} image={details?.eventData?.image} />

          <InfoCard heading="Organization" title={details?.organizationData?.name} image={details?.organizationData?.logo} />
        </div>
      )}
    </div>
  );
}
